import React from 'react'
import Typography from '@material-ui/core/Typography'
import { useFormikContext } from 'formik'
import get from 'lodash/get'

interface HighLevelErrorProps {
  name: string
}

const HighLevelError: React.FC<HighLevelErrorProps> = ({ name }) => {
  const { errors } = useFormikContext()

  const message = get(errors, name)

  return message !== undefined ? (
    <Typography variant='body2' color='error'>
      {message}
    </Typography>
  ) : null
}

export default HighLevelError
